const create = (api) => {
    const getAccessPoints = ( pageNumber = 1, pageSize = 100, sort = '', directionSort = 1, query = '', siteId, params = {} ) => {
        const queryParam = query ? `&query=${query}` : `&query=`;
        const url = `/dashboard/v1/stats/accesspoints/${siteId}?sort=${sort}&directionSort=${directionSort}${queryParam}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
        return api.get(url, params);
    }

    return {
        getAccessPoints
    }
}

export default {
    create
}
